<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Program Bottleneck Courses"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('program_bottleneck_courses')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Program Bottleneck
      Courses Tool. The Program Bottleneck Courses Toll displays 5 courses with
      lowest pass rates based on a program for different years and semesters.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Success Metrics Section
          <i class="fa-solid fa-arrow-right"></i> Program Bottleneck Courses
        </h1>

        <div class="buttons-nav">
          <div class="example-button-row">
            <nav-page-link
              text="Bottleneck Filter Guide"
              targetId="formguide"
              tooltipMessage="Navigate down"
            ></nav-page-link>
            <span> &nbsp; | &nbsp; </span>
            <nav-page-link
              text="Program Bottleneck Table Result"
              targetId="results"
              tooltipMessage="Navigate down"
            ></nav-page-link>
          </div>
        </div>

        <!---------- Program Bottleneck Courses Tool At First Glance ---------->

        <h3 class="h3-second-header">
          Prerequisite Impact Tool At First Glance
        </h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 23.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageProgramBottleneckFig23']"
            alt=""
          />
          <p class="picture-caption">
            Figure 23: Program Bottleneck Courses Tool Page
          </p>
        </div>

        <div id="formguide"></div>
        <br />
        <mat-divider></mat-divider>
        <br />

        <!---------- Program Bottleneck Courses Form Guide ---------->
        <h3 class="h3-second-header">
          Program Bottleneck Courses Form Submission
        </h3>

        <ol class="ordered-list">
          <li>
            Select the College (Lewis Bear Jr College of Business; College of
            Arts, Social Sciences and Humanities; Hal Marcus of College of
            Science and Engineering; Usha Kundu, MD College of Health; School of
            Education; No College Designated)
          </li>
          <li>
            Select the Program (Example: Computer Science [If previous form
            field was Hal Marcus of College of Science and Engineering])
          </li>
          <li>Select the Year (All, UWFYear1, UWFYear2, UWFYear3, UWFYear4)</li>
          <li>Select the Semester (Fall, Spring, Summer)</li>
          <li>
            * Lastly, click on the ‘Submit’ button to generate results Program
            Bottleneck Courses.
          </li>
        </ol>
        <br />
      </div>

      <div class="left-align-div">
        <div>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageProgramBottleneckFig23a']"
            alt=""
          />
          <p class="picture-caption">Figure 23a: Bottleneck Filter</p>
        </div>
      </div>

      <!--------------- Results After Form Submission Explanation --------------->
      <div class="left-align-div" id="results">
        <br />
        <mat-divider></mat-divider>
        <br />
        <h3 class="h3-second-header">Results After Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After submitting the form, you will get a table just like the
            screenshot (Figure 24) below. You will be able to expand each row to
            view the course description.
          </li>
          <div>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageProgramBottleneckFig24']"
              alt=""
            />
            <p class="picture-caption">
              Figure 24: Program Bottleneck Result Table
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getSuccessMetricsRelatedLinkBasedOnTool(
        'Program Bottleneck Courses',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
